"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadEnums = void 0;
const config_1 = require("./config");
const spring_connect_1 = require("@42.nl/spring-connect");
/**
 * Loads the enums from the back-end.
 *
 * The URL it will send the request to is defined by the 'enumsUrl'
 * from the Config object. The HTTP method it uses is 'get'.
 *
 * It will also send the credentials if 'needsAuthentication' from
 * the Config object is set to true.
 *
 * The entire response will be written to the Redux EnumsStore's
 * enums key. Whatever the JSON response is will be the enums.
 *
 *  An example response:
 *
 * ```JSON
 * {
 *   "UserRole": [
 *     "ADMIN",
 *     "USER"
 *  ],
 *  "BillingInterval": [
 *    "MONTHLY", "WEEKLY", "DAILY"
 *  ]
 * ```
 *
 * @returns {Promise}
 */
function loadEnums() {
    return __awaiter(this, void 0, void 0, function* () {
        const { enumsUrl } = (0, config_1.getConfig)();
        const service = (0, config_1.getService)();
        const enums = yield (0, spring_connect_1.get)(enumsUrl);
        service.setEnums(enums);
    });
}
exports.loadEnums = loadEnums;
